import React, {useState} from 'react';
import Modal from '../../Modal';
import LabelPrinter from './LabelPrinter';

/** Modal wrapper around the label printer. The printer mounts only while the modal is open. */
export default function LabelPrinterModal({isOpen, onClose, initialOrderUuids = []}) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Print labels and packing slips"
      size="fullscreen"
    >
      <LabelPrinter
        variant="modal"
        initialOrderUuids={initialOrderUuids}
        onClose={onClose}
      />
    </Modal>
  );
}

/** Button that opens the modal variant. Used on bktestpage until Phase 5 wires OrdersManager. */
export function LabelPrinterModalButton({initialOrderUuids = []}) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="label-printer-modal-button">
      <button type="button" onClick={() => setIsOpen(true)}>
        Open label printer modal
      </button>
      <LabelPrinterModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        initialOrderUuids={initialOrderUuids}
      />
    </div>
  );
}
